import { IWorkgroup, IWorkgroupData } from '../workgroup.types';
import { Workgroup } from '../workgroup';

export const mockWorkgroupsData = (): IWorkgroupData[] => [
  {
    id: 1,
    name: 'Technical Associate I',
    description: 'IT'
  },
  {
    id: 2,
    name: 'Technical Associate II',
    description: 'Engineering'
  }
];

export const mockWorkgroups = (
  data: IWorkgroupData[] = mockWorkgroupsData()
): IWorkgroup[] => data.map(item => new Workgroup(item));
